import React, { PureComponent } from 'react';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import { CLOSED_ID, TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
import { convertMessage, getStartIndex } from '../../../utils';
import ChatContent from '../../MessageIndex/ChatContent';
import ChatPdf from '../../molecules/ChatPdf';
import NewMessageForm from '../../organisms/NewMessageForm';
import Head from './Head';
import { BodyDiv, ContainerDiv, FooterDiv } from './styles';
var ConnectionStatus = /*#__PURE__*/function (ConnectionStatus) {
  ConnectionStatus[ConnectionStatus["LOADING"] = 0] = "LOADING";
  ConnectionStatus[ConnectionStatus["LOADED"] = 1] = "LOADED";
  ConnectionStatus[ConnectionStatus["ERROR"] = 2] = "ERROR";
  return ConnectionStatus;
}(ConnectionStatus || {});
export class PopUp extends PureComponent {
  constructor(props) {
    super(props);
    this.locationChat = React.createRef();
    this.endOfMessagesRef = React.createRef();
    this.convertMessage = message => {
      return convertMessage(message, this.props.project, this.props.user, this.props.suggestedPartners);
    };
    this.handleMessageAdded = message => {
      this.setState(({
        messages
      }) => ({
        messages: messages.concat(this.convertMessage(message))
      }));
      if (this.props.user.identity === message.author) {
        this.props.conversation.setAllMessagesRead();
      }
      this.scrollToBottom();
    };
    this.scrollToBottom = () => {
      this.endOfMessagesRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    };
    this.state = {
      connectionStatus: ConnectionStatus.LOADING,
      isPdfModalVisible: false,
      messages: []
    };
  }
  async componentDidMount() {
    let page;
    try {
      page = await this.props.conversation.getMessages(15);
    } catch (e) {
      this.setState({
        connectionStatus: ConnectionStatus.ERROR
      });
      throw e;
    }
    this.props.conversation.setAllMessagesRead().catch(() => {});
    this.props.conversation.on('messageAdded', this.handleMessageAdded);
    this.setState({
      connectionStatus: ConnectionStatus.LOADED,
      currentMessagePage: page,
      messages: page.items.map(message => this.convertMessage(message))
    });
    this.scrollToBottom();
  }
  componentWillUnmount() {
    this.props.conversation.off('messageAdded', this.handleMessageAdded);
  }
  async getMoreMessages() {
    if (!(this.state.currentMessagePage && this.state.currentMessagePage.hasPrevPage)) {
      return;
    }
    const page = await this.state.currentMessagePage.prevPage();
    const olderMessages = page.items.map(this.convertMessage.bind(this));
    this.setState(({
      messages
    }) => ({
      currentMessagePage: page,
      messages: [...olderMessages, ...messages]
    }));
  }
  render() {
    const isChatClosed = this.props.project?.status === CLOSED_ID && this.props.project?.twilio_client_partner === this.props.conversation.sid;
    const isActive = this.props.conversation.sid === this.props.activeSid;
    return <>
        <ContainerDiv className={isActive ? 'active' : ''} isHidden={this.props.isHidden} ref={this.locationChat}>
          {this.props.isHeaderHidden && !isActive && !this.props.isOpen ? undefined : <Head charIcon={this.props.charIcon} closeChat={this.props.closeChat} downloadMessages={() => this.setState({
          isPdfModalVisible: true
        })} id={this.props.conversation.sid} isActive={isActive && this.props.isOpen} isAdmin={this.props.isAdmin} isDM={this.props.isDM} isStarred={this.props.isStarred} onClickToggle={ids => {
          this.props.toggleChat(ids, this.locationChat.current.offsetLeft);
        }} setIsStarred={this.props.toggleStarred} title={this.props.title} />}
          <BodyDiv>
            {this.state.connectionStatus === ConnectionStatus.ERROR ? 'Error: could not load messages' : this.state.connectionStatus === ConnectionStatus.LOADING ? <div style={{
            paddingTop: '20px'
          }}>
                <LoadingSpinner2 margin={50} />
              </div> : <ChatContent endRef={this.endOfMessagesRef} getMoreMessages={this.getMoreMessages.bind(this)} messages={this.state.messages} twilioClient={this.props.twilioClient} user={this.props.user} />}
          </BodyDiv>
          <FooterDiv>
            {this.state.connectionStatus === ConnectionStatus.LOADED && <NewMessageForm conversation={this.props.conversation} currentUser={this.props.user} isAdmin={this.props.twilioClient?.user.identity === TWILIO_ADMIN_IDENTITY} isDisabled={isChatClosed} onSendFailure={this.props.refreshToken} projectId={this.props.projectId} startIndex={getStartIndex(this.state.messages)} disableFileUpload={this.props.disableFileUpload} />}
          </FooterDiv>
        </ContainerDiv>
        {this.state.connectionStatus === ConnectionStatus.LOADED && <ChatPdf currentUserId={this.props.user.id} isVisible={this.state.isPdfModalVisible} messages={this.state.messages} onCancel={() => this.setState({
        isPdfModalVisible: false
      })} onOk={() => this.setState({
        isPdfModalVisible: false
      })} title={this.props.conversation.attributes.project_name ?? ''} />}
      </>;
  }
}
export default PopUp;